module.exports = __webpack_public_path__ + "f66387a6772fa3b6d564f818bbcb68c1.MP3";